import { css } from 'lit';

export default css`
  .achievement-card-container {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5em;
  }

  amityeko-tg-body-two {
    color: #0f86fe;
    cursor: pointer;
  }
`;
